import React from "react";
import { Container, Paper, Stack } from "@mui/material";
import { useAuth } from "../auth/AuthContext";
import { hasAccountingAccess } from "../../subscription";
import SupplierUpgradeNotice from "./supplierManagement/SupplierUpgradeNotice";
import SupplierManagementHeader from "./supplierManagement/SupplierManagementHeader";
import SupplierSearchBar from "./supplierManagement/SupplierSearchBar";
import SupplierContent from "./supplierManagement/SupplierContent";
import SupplierFormDialog from "./supplierManagement/SupplierFormDialog";
import DeleteSupplierDialog from "./supplierManagement/DeleteSupplierDialog";
import SupplierToast from "./supplierManagement/SupplierToast";
import { useSupplierManagement } from "./supplierManagement/useSupplierManagement";

export default function SupplierManagement() {
    const { user } = useAuth();
    const hasAccounting = hasAccountingAccess(user?.paymentPlan);

    const {
        error,
        loading,
        query,
        filteredSuppliers,
        groupedSuppliers,
        dialogOpen,
        currentSupplier,
        saving,
        fieldErrors,
        deleteAsk,
        toast,
        setError,
        setQuery,
        setDeleteAsk,
        handleDialogOpen,
        handleDialogClose,
        handleEdit,
        handleSave,
        confirmDelete,
        handleRefresh,
        handleFieldChange,
        closeToast,
    } = useSupplierManagement({ hasAccounting });

    if (!hasAccounting) {
        return <SupplierUpgradeNotice />;
    }

    return (
        <>
            <SupplierManagementHeader onRefresh={handleRefresh} onCreate={handleDialogOpen} />

            <Container maxWidth="lg" sx={{ mt: 3 }}>
                <Paper variant="outlined" sx={{ p: { xs: 2.5, md: 3.5 }, borderRadius: 3 }}>
                    <Stack spacing={3}>
                        <SupplierSearchBar
                            query={query}
                            onChange={setQuery}
                            onClear={() => setQuery("")}
                        />
                        <SupplierContent
                            error={error}
                            loading={loading}
                            hasResults={filteredSuppliers.length > 0}
                            groups={groupedSuppliers}
                            onClearError={() => setError(null)}
                            onEdit={handleEdit}
                            onDelete={setDeleteAsk}
                        />
                    </Stack>
                </Paper>
            </Container>

            <SupplierFormDialog
                open={dialogOpen}
                supplier={currentSupplier}
                fieldErrors={fieldErrors}
                saving={saving}
                onClose={handleDialogClose}
                onFieldChange={handleFieldChange}
                onSave={handleSave}
            />

            <DeleteSupplierDialog supplier={deleteAsk} onCancel={() => setDeleteAsk(null)} onConfirm={confirmDelete} />

            <SupplierToast toast={toast} onClose={closeToast} />
        </>
    );
}
